/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * GTO Wizard API v4
 * API documentation for GTO Wizard frontend API
 * OpenAPI spec version: 4
 */
import { useMutation, useQuery } from '@tanstack/vue-query'
import type {
  DataTag,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query'

import { unref } from 'vue'
import type { MaybeRef } from 'vue'

import type {
  AdyenActiveCardResponse,
  AdyenConfirmResultRequest,
  AdyenConfirmResultResponse,
  AdyenCreditsPayment200,
  AdyenCreditsPaymentRequest,
  AdyenPaymentSessionResponse,
  AdyenSubscriptionCreateRequest,
  AdyenSubscriptionUpdateRequest,
  AdyenWebhookData,
} from '../models'

import adyenCreditsPaymentMutator from '../../../client'
import adyenActiveCardMutator from '../../../client'
import adyenSubscriptionCreateMutator from '../../../client'
import adyenSubscriptionUpdateMutator from '../../../client'
import adyenSubscriptionCancelDowngradeMutator from '../../../client'
import adyenSubscriptionReactivateMutator from '../../../client'
import adyenWebhookMutator from '../../../client'
import adyenConfirmResultMutator from '../../../client'

type AwaitedInput<T> = PromiseLike<T> | T

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never

/**
 * @summary Adyen Credits Payment
 */
export const adyenCreditsPayment = (
  adyenCreditsPaymentRequest: MaybeRef<AdyenCreditsPaymentRequest>,
  signal?: AbortSignal,
) => {
  adyenCreditsPaymentRequest = unref(adyenCreditsPaymentRequest)

  return adyenCreditsPaymentMutator<AdyenCreditsPayment200>({
    url: `/v4/payments/adyen/credits/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: adyenCreditsPaymentRequest,
    signal,
  })
}

export const getAdyenCreditsPaymentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adyenCreditsPayment>>,
    TError,
    { data: AdyenCreditsPaymentRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof adyenCreditsPayment>>,
  TError,
  { data: AdyenCreditsPaymentRequest },
  TContext
> => {
  const mutationKey = ['adyenCreditsPayment']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adyenCreditsPayment>>,
    { data: AdyenCreditsPaymentRequest }
  > = props => {
    const { data } = props ?? {}

    return adyenCreditsPayment(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdyenCreditsPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof adyenCreditsPayment>>
>
export type AdyenCreditsPaymentMutationBody = AdyenCreditsPaymentRequest
export type AdyenCreditsPaymentMutationError = unknown

/**
 * @summary Adyen Credits Payment
 */
export const useAdyenCreditsPayment = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adyenCreditsPayment>>,
    TError,
    { data: AdyenCreditsPaymentRequest },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof adyenCreditsPayment>>,
  TError,
  { data: AdyenCreditsPaymentRequest },
  TContext
> => {
  const mutationOptions = getAdyenCreditsPaymentMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Adyen Active Card
 */
export const adyenActiveCard = (signal?: AbortSignal) => {
  return adyenActiveCardMutator<AdyenActiveCardResponse | void>({
    url: `/v4/payments/adyen/active-card/`,
    method: 'GET',
    signal,
  })
}

export const getAdyenActiveCardQueryKey = () => {
  return ['v4', 'payments', 'adyen', 'active-card'] as const
}

export const getAdyenActiveCardQueryOptions = <
  TData = Awaited<ReturnType<typeof adyenActiveCard>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adyenActiveCard>>, TError, TData>>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = getAdyenActiveCardQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adyenActiveCard>>> = ({ signal }) =>
    adyenActiveCard(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adyenActiveCard>>,
    TError,
    TData
  >
}

export type AdyenActiveCardQueryResult = NonNullable<Awaited<ReturnType<typeof adyenActiveCard>>>
export type AdyenActiveCardQueryError = unknown

/**
 * @summary Adyen Active Card
 */

export function useAdyenActiveCard<
  TData = Awaited<ReturnType<typeof adyenActiveCard>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adyenActiveCard>>, TError, TData>>
}): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdyenActiveCardQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>

  return query
}

/**
 * @summary Adyen Subscription Create
 */
export const adyenSubscriptionCreate = (
  adyenSubscriptionCreateRequest: MaybeRef<AdyenSubscriptionCreateRequest>,
  signal?: AbortSignal,
) => {
  adyenSubscriptionCreateRequest = unref(adyenSubscriptionCreateRequest)

  return adyenSubscriptionCreateMutator<AdyenPaymentSessionResponse>({
    url: `/v4/payments/adyen/subscriptions/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: adyenSubscriptionCreateRequest,
    signal,
  })
}

export const getAdyenSubscriptionCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adyenSubscriptionCreate>>,
    TError,
    { data: AdyenSubscriptionCreateRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof adyenSubscriptionCreate>>,
  TError,
  { data: AdyenSubscriptionCreateRequest },
  TContext
> => {
  const mutationKey = ['adyenSubscriptionCreate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adyenSubscriptionCreate>>,
    { data: AdyenSubscriptionCreateRequest }
  > = props => {
    const { data } = props ?? {}

    return adyenSubscriptionCreate(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdyenSubscriptionCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof adyenSubscriptionCreate>>
>
export type AdyenSubscriptionCreateMutationBody = AdyenSubscriptionCreateRequest
export type AdyenSubscriptionCreateMutationError = unknown

/**
 * @summary Adyen Subscription Create
 */
export const useAdyenSubscriptionCreate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adyenSubscriptionCreate>>,
    TError,
    { data: AdyenSubscriptionCreateRequest },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof adyenSubscriptionCreate>>,
  TError,
  { data: AdyenSubscriptionCreateRequest },
  TContext
> => {
  const mutationOptions = getAdyenSubscriptionCreateMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Adyen Subscription Update
 */
export const adyenSubscriptionUpdate = (
  subscriptionId: MaybeRef<string>,
  adyenSubscriptionUpdateRequest: MaybeRef<AdyenSubscriptionUpdateRequest>,
) => {
  subscriptionId = unref(subscriptionId)
  adyenSubscriptionUpdateRequest = unref(adyenSubscriptionUpdateRequest)

  return adyenSubscriptionUpdateMutator<void | AdyenPaymentSessionResponse>({
    url: `/v4/payments/adyen/subscriptions/${subscriptionId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: adyenSubscriptionUpdateRequest,
  })
}

export const getAdyenSubscriptionUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adyenSubscriptionUpdate>>,
    TError,
    { subscriptionId: string; data: AdyenSubscriptionUpdateRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof adyenSubscriptionUpdate>>,
  TError,
  { subscriptionId: string; data: AdyenSubscriptionUpdateRequest },
  TContext
> => {
  const mutationKey = ['adyenSubscriptionUpdate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adyenSubscriptionUpdate>>,
    { subscriptionId: string; data: AdyenSubscriptionUpdateRequest }
  > = props => {
    const { subscriptionId, data } = props ?? {}

    return adyenSubscriptionUpdate(subscriptionId, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdyenSubscriptionUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof adyenSubscriptionUpdate>>
>
export type AdyenSubscriptionUpdateMutationBody = AdyenSubscriptionUpdateRequest
export type AdyenSubscriptionUpdateMutationError = unknown

/**
 * @summary Adyen Subscription Update
 */
export const useAdyenSubscriptionUpdate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adyenSubscriptionUpdate>>,
    TError,
    { subscriptionId: string; data: AdyenSubscriptionUpdateRequest },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof adyenSubscriptionUpdate>>,
  TError,
  { subscriptionId: string; data: AdyenSubscriptionUpdateRequest },
  TContext
> => {
  const mutationOptions = getAdyenSubscriptionUpdateMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Adyen Subscription Cancel Downgrade
 */
export const adyenSubscriptionCancelDowngrade = (
  subscriptionId: MaybeRef<string>,
  signal?: AbortSignal,
) => {
  subscriptionId = unref(subscriptionId)

  return adyenSubscriptionCancelDowngradeMutator<void>({
    url: `/v4/payments/adyen/subscriptions/${subscriptionId}/cancel-downgrade/`,
    method: 'POST',
    signal,
  })
}

export const getAdyenSubscriptionCancelDowngradeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adyenSubscriptionCancelDowngrade>>,
    TError,
    { subscriptionId: string },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof adyenSubscriptionCancelDowngrade>>,
  TError,
  { subscriptionId: string },
  TContext
> => {
  const mutationKey = ['adyenSubscriptionCancelDowngrade']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adyenSubscriptionCancelDowngrade>>,
    { subscriptionId: string }
  > = props => {
    const { subscriptionId } = props ?? {}

    return adyenSubscriptionCancelDowngrade(subscriptionId)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdyenSubscriptionCancelDowngradeMutationResult = NonNullable<
  Awaited<ReturnType<typeof adyenSubscriptionCancelDowngrade>>
>

export type AdyenSubscriptionCancelDowngradeMutationError = unknown

/**
 * @summary Adyen Subscription Cancel Downgrade
 */
export const useAdyenSubscriptionCancelDowngrade = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adyenSubscriptionCancelDowngrade>>,
    TError,
    { subscriptionId: string },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof adyenSubscriptionCancelDowngrade>>,
  TError,
  { subscriptionId: string },
  TContext
> => {
  const mutationOptions = getAdyenSubscriptionCancelDowngradeMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Adyen Subscription Reactivate
 */
export const adyenSubscriptionReactivate = (
  subscriptionId: MaybeRef<string>,
  signal?: AbortSignal,
) => {
  subscriptionId = unref(subscriptionId)

  return adyenSubscriptionReactivateMutator<void>({
    url: `/v4/payments/adyen/subscriptions/${subscriptionId}/reactivate/`,
    method: 'POST',
    signal,
  })
}

export const getAdyenSubscriptionReactivateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adyenSubscriptionReactivate>>,
    TError,
    { subscriptionId: string },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof adyenSubscriptionReactivate>>,
  TError,
  { subscriptionId: string },
  TContext
> => {
  const mutationKey = ['adyenSubscriptionReactivate']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adyenSubscriptionReactivate>>,
    { subscriptionId: string }
  > = props => {
    const { subscriptionId } = props ?? {}

    return adyenSubscriptionReactivate(subscriptionId)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdyenSubscriptionReactivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof adyenSubscriptionReactivate>>
>

export type AdyenSubscriptionReactivateMutationError = unknown

/**
 * @summary Adyen Subscription Reactivate
 */
export const useAdyenSubscriptionReactivate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adyenSubscriptionReactivate>>,
    TError,
    { subscriptionId: string },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof adyenSubscriptionReactivate>>,
  TError,
  { subscriptionId: string },
  TContext
> => {
  const mutationOptions = getAdyenSubscriptionReactivateMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Adyen Webhook
 */
export const adyenWebhook = (
  adyenWebhookData: MaybeRef<AdyenWebhookData>,
  signal?: AbortSignal,
) => {
  adyenWebhookData = unref(adyenWebhookData)

  return adyenWebhookMutator<string>({
    url: `/v4/payments/adyen/webhook/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: adyenWebhookData,
    signal,
  })
}

export const getAdyenWebhookMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adyenWebhook>>,
    TError,
    { data: AdyenWebhookData },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof adyenWebhook>>,
  TError,
  { data: AdyenWebhookData },
  TContext
> => {
  const mutationKey = ['adyenWebhook']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adyenWebhook>>,
    { data: AdyenWebhookData }
  > = props => {
    const { data } = props ?? {}

    return adyenWebhook(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdyenWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof adyenWebhook>>>
export type AdyenWebhookMutationBody = AdyenWebhookData
export type AdyenWebhookMutationError = unknown

/**
 * @summary Adyen Webhook
 */
export const useAdyenWebhook = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adyenWebhook>>,
    TError,
    { data: AdyenWebhookData },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof adyenWebhook>>,
  TError,
  { data: AdyenWebhookData },
  TContext
> => {
  const mutationOptions = getAdyenWebhookMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Adyen Confirm Result
 */
export const adyenConfirmResult = (
  adyenConfirmResultRequest: MaybeRef<AdyenConfirmResultRequest>,
  signal?: AbortSignal,
) => {
  adyenConfirmResultRequest = unref(adyenConfirmResultRequest)

  return adyenConfirmResultMutator<AdyenConfirmResultResponse>({
    url: `/v4/payments/adyen/confirm-result/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: adyenConfirmResultRequest,
    signal,
  })
}

export const getAdyenConfirmResultMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adyenConfirmResult>>,
    TError,
    { data: AdyenConfirmResultRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof adyenConfirmResult>>,
  TError,
  { data: AdyenConfirmResultRequest },
  TContext
> => {
  const mutationKey = ['adyenConfirmResult']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adyenConfirmResult>>,
    { data: AdyenConfirmResultRequest }
  > = props => {
    const { data } = props ?? {}

    return adyenConfirmResult(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type AdyenConfirmResultMutationResult = NonNullable<
  Awaited<ReturnType<typeof adyenConfirmResult>>
>
export type AdyenConfirmResultMutationBody = AdyenConfirmResultRequest
export type AdyenConfirmResultMutationError = unknown

/**
 * @summary Adyen Confirm Result
 */
export const useAdyenConfirmResult = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adyenConfirmResult>>,
    TError,
    { data: AdyenConfirmResultRequest },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof adyenConfirmResult>>,
  TError,
  { data: AdyenConfirmResultRequest },
  TContext
> => {
  const mutationOptions = getAdyenConfirmResultMutationOptions(options)

  return useMutation(mutationOptions)
}
